import {BaseDomainModel} from "../../../../infrastructure/models/base-domain-model";
import {FoulsApiModel} from "./fouls.api-model";

export class FoulsDomainModel extends BaseDomainModel {
  apiModel: FoulsApiModel;

  get current(): Number {
    return this.apiModel.current;
  }

  get total(): Number {
    return this.apiModel.total;
  }

  get hasBonus(): Boolean {
    return this.apiModel.hasBonus;
  }
}
